import { create } from "zustand";

const AddProjectStore = create((set) => ({
  // Initial state
  addProject: {
    open: false,
    type: "",
    step: 1,
    domainUrl: "",
    project_name: "",
    project_id: null,
    language: null,
    location: null,
    competitors: [],
    device_type: null,
    keyword: [],
    complete_steps: [],
    project_usage: { limits: [], loading: true, error: false },
  },

  // Actions
  setAddProjectField: (field, value) =>
    set((state) => ({
      addProject: {
        ...state.addProject,
        [field]: value,
      },
    })),

  setMultipleFields: (fields) =>
    set((state) => ({
      addProject: {
        ...state.addProject,
        ...fields,
      },
    })),

  resetAddProject: () =>
    set(() => ({
      addProject: {
        open: false,
        type: "",
        step: 1,
        domainUrl: "",
        project_name: "",
        project_id: null,
        language: null,
        location: null,
        competitors: [],
        device_type: null,
        keyword: [],
        complete_steps: [],
        project_usage: { limits: [], loading: true, error: false },
      },
    })),

  //modal
  modal_visible: false,
  setModalVisibility: (visible) =>
    set({
      modal_visible: visible,
    }),
  // useNotificationStore
  open: false,
  message: "",
  severity: "info", // 'success', 'error', 'warning', 'info'

  showNotification: ({ message = "", severity = "info" }) =>
    set({ open: true, message, severity }),
  hideNotification: () => set({ open: false }),

  //translate
  local: "en",
  translateLanguage: (lang) => set({ local: lang }),

  // new user answer module popup
  user_answer: {
    open: false,
    email: null,
  },

  // whitelable
  whitelable_loaded: false,
  appliedWhiteLable: {
    header_logo: null,
    show_translation: true,
    show_upgrade: true,
    show_affiliate: true,
    show_header_links: true,
    show_header_custom_links: false,
    header_custom_links: [],
    theme_color: null,
    theme_color_list: [],
    show_footer_links: true,
    show_footer_custom_links: false,
    custom_links: [],
    favicon: null,
  },
  white_lable: {
    isUpdate: false,
    header_logo: null,
    show_translation: true,
    show_upgrade: true,
    show_affiliate: true,
    show_header_links: true,
    show_header_custom_links: false,
    header_custom_links: [],
    theme_color: null,
    theme_color_list: [],
    show_footer_links: true,
    show_footer_custom_links: false,
    custom_links: [],
    favicon: null,
  },

  // rank-tracking refresh
  refresh_ranking: {
    data: [],
  },
  // map-tracking refresh
  refresh_map_ranking: {
    data: [],
  },
  // ai-tracking refresh
  refresh_ai_ranking: {
    data: [],
  },
}));

export default AddProjectStore;
